import { Button, styled,Box } from "@mui/material";

export  const StyledContinueButton = styled(Button)(()=>({
    borderRadius: "6px",
    textTransform: "none",
    fontFamily: "Montserrat, -apple-system, Roboto, Helvetica, sans-serif",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "120%",
    letterSpacing: "-1px",
    fontSize: "18px",
    background: "var(--Header-Bg-Dark-cyan-blue-Color, #4598A6)",
    padding: "10px 20px",
    color:"#fff"
}))
export  const StyledCancelButton = styled(Button)(()=>({
    borderRadius: "6px",
    textTransform: "none",
    fontFamily: "Montserrat, -apple-system, Roboto, Helvetica, sans-serif",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "120%",
    letterSpacing: "-1px",
    fontSize: "18px",
    background: "#4B5253",
    padding: "10px 20px"
}))
export  const StyledBackButton = styled(Button)(()=>({
    borderRadius: "6px",
    textTransform: "none",
    fontFamily: "Montserrat, -apple-system, Roboto, Helvetica, sans-serif",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "120%",
    letterSpacing: "-1px",
    fontSize: "18px",
    background: "#DADCDC",
    color:"black",
    padding: "10px 20px"
}))
export  const StyledButtonContainer = styled(Box)(({theme})=>({
    display: "flex",
    justifyContent: "flex-end",
    gap: "16px", // MUI spacing (2 * 8px = 16px)
    marginTop:"15px",  // MUI spacing (3 * 8px = 24px, closest to 25px)
    // marginBottom:"25px"
}))
export  const StyledActAndDeActButton = styled(Button)(()=>({
    borderRadius: "6px",
    textTransform: "none",
    fontFamily: "Montserrat, -apple-system, Roboto, Helvetica, sans-serif",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "120%",
    letterSpacing: "-1px",
    fontSize: "18px",
    padding: "10px "
}))